__turbopack_context__.v({
  "carouselButton": "CarouselButtons-module__8kwsrG__carouselButton",
  "carouselButtonNext": "CarouselButtons-module__8kwsrG__carouselButtonNext",
  "carouselButtonPrevious": "CarouselButtons-module__8kwsrG__carouselButtonPrevious",
  "withDropShadow": "CarouselButtons-module__8kwsrG__withDropShadow",
});
